import { AccessTime } from "@mui/icons-material";
import { TimePicker } from "@mui/x-date-pickers";
import { useField, useFormikContext } from "formik";
import { buildArtFieldLabel } from "./artFieldLabelUtils";
import { useArtFieldMetadata } from "./artFieldMetadataContext";

// Estilo del ícono
const StyledIcon = {
  color: "inherit",
};

// Estilo del picker
const StyledPicker = {
  marginTop: 8,
  marginBottom: 8,
};

const FormikTimePicker = (props) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  const fieldMetadata = useArtFieldMetadata(props.name);
  const label = buildArtFieldLabel(props.label, fieldMetadata);

  const handleChange = (value) => {
    setFieldValue(props.name, value);
  };

  return (
    <TimePicker
      variant="inline"
      autoOk={true}
      timeSteps={{ minutes: 1 }}
      slotProps={{
        textField: {
          variant: "standard",
          error: meta.touched && meta.error ? true : false,
          helperText: meta.touched && meta.error ? meta.error : null,
        },
      }}
      ampm={false}
      keyboardIcon={<AccessTime sx={StyledIcon} />}
      {...props}
      {...field}
      label={label}
      onChange={handleChange}
      sx={StyledPicker}
    />
  );
};

export default FormikTimePicker;
